import Notice from './notice';

export default Notice;
